import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "user-interface"
    }}>{`User Interface`}</h1>
    <p>{`The user interface section will provide guidance around the different UXP Spectrum components you can use to build a plugin UI. For guidance around the UX of a plugin and best practices refer to `}<a parentName="p" {...{
        "href": "../ux-patterns/"
      }}>{`UX patterns`}</a>{`.`}</p>
    <p>{`Visit the `}<a parentName="p" {...{
        "href": "https://spectrum.adobe.com"
      }}>{`Adobe Spectrum website`}</a>{` to reference `}</p>
    <ul>
      <li parentName="ul">{`Styling`}</li>
      <li parentName="ul">{`Behaviors`}</li>
      <li parentName="ul">{`Usage guidelines`}</li>
      <li parentName="ul">{`Download UI files and more`}</li>
    </ul>
    <h2 {...{
      "id": "uxp-spectrum-components"
    }}>{`UXP Spectrum Components`}</h2>
    <p>{`Spectrum UXP allows UI to be the same for plugins across XD and Photoshop and support themes. Below is a list to all the components available in UXP and the Spectrum design gudelines. `}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/action-button/"
        }}>{`Action button`}</a></strong>{` -
Action buttons allow users to perform an action or mark a selection. They’re used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren’t meant to draw a lot of attention.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/button/"
        }}>{`Button`}</a></strong>{` -
Buttons allow users to perform an action or to navigate to another page. They have multiple styles for various needs, and are ideal for calling attention to where a user needs to do something in order to move forward in a flow.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/checkbox/"
        }}>{`Checkbox`}</a></strong>{` -
Checkboxes allow users to select multiple items from a list of individual items, or to mark one individual item as selected.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/divider/"
        }}>{`Divider`}</a></strong>{` -
Dividers bring clarity to a layout by grouping and dividing content in close proximity. They can also be used to establish rhythm and hierarchy.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/link/"
        }}>{`Link`}</a></strong>{` -
Links allow users to navigate to a different location. They can be presented inline inside a paragraph or as standalone text.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/picker/"
        }}>{`Picker`}</a></strong>{` -
Pickers (sometimes known as "dropdowns" or "selects") allow users to choose from a list of options in a limited space. The list of options can change based on the context.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/radio-button/"
        }}>{`Radio Button`}</a></strong>{` -
Radio buttons allow users to select a single option from a list of mutually exclusive options. All possible options are exposed up front for users to compare.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/slider/"
        }}>{`Slider`}</a></strong>{` -
Sliders allow users to quickly select a value within a range. They should be used when the upper and lower bounds to the range are invariable.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/text-field/"
        }}>{`Text Field`}</a></strong>{` -
Text fields are text boxes that allow users to input custom text entries with a keyboard. Various options can be shown with the field to communicate the input requirements.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/tooltip/"
        }}>{`Tooltip`}</a></strong>{` -
Tooltips allow users to get contextual help or information about specific components when hovering or focusing on them.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://spectrum.adobe.com/page/heading/"
        }}>{`Typography`}</a></strong>{` -
Typography components include Heading, Body, and Detail. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      